import { Tag, TagLabel, TagLeftIcon, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FaGlobe, FaLock } from 'react-icons/fa';

function AccessTag({ isPrivate, ...rest }) {
  return (
    <Tooltip
      {...rest}
      label={
        isPrivate
          ? 'This can only be accessed via specific access list or class'
          : 'This can be accessed by all trainees'
      }
    >
      <Tag size="sm" colorScheme={isPrivate ? 'red' : 'green'} variant="solid">
        <TagLeftIcon as={isPrivate ? FaLock : FaGlobe} />
        <TagLabel>{isPrivate ? 'Private' : 'Global'}</TagLabel>
      </Tag>
    </Tooltip>
  );
}

AccessTag.defaultProps = {
  isPrivate: false,
};

AccessTag.propTypes = {
  isPrivate: PropTypes.bool,
};

export default AccessTag;
